import React from 'react';
import { ClipboardX } from 'lucide-react';
import WorkItem from './WorkItem';
import { WorkItem as WorkItemType, WorkItemEstimate } from '../../models/workItem';

interface WorkItemListProps {
  workItems: WorkItemType[];
  analysisResults: { [workItemId: string]: WorkItemEstimate };
  onAnalyzeWorkItem: (workItemId: string) => void;
  propertyId: string;
  address: string;
}

const WorkItemList: React.FC<WorkItemListProps> = ({
  workItems,
  analysisResults,
  onAnalyzeWorkItem,
  propertyId,
  address,
}) => {
  return (
    <div className="w-full mb-6">
      <ul className="space-y-4 w-full">
        {workItems.map((item) => (
          <WorkItem
            key={item.id}
            workItem={item}
            quote={undefined}
            onAnalyze={() => onAnalyzeWorkItem(item.id)} 
            propertyId={propertyId}
            address={address}      
          />
        ))}
      </ul>
      
      {workItems.length === 0 && (
        <div className="mt-6 text-center flex flex-col items-center justify-center p-8 rounded-lg border border-dashed border-slate-300">
          <ClipboardX className="h-12 w-12 text-slate-400 mb-2" />
          <p className="text-slate-600 font-medium">
            No work items available.
          </p>
        </div>
      )}
    </div>
  );
};

export default WorkItemList;
